module.exports = __webpack_public_path__ + "img/thumbnail_Aardvark_m_normal.fac2f179.png";